import React, {useCallback} from 'react';
import {FormControl} from '@mui/material';
import {SportSelectInput} from '@/components/forms/input/sports';

interface SportFilterProps {
  sports: string[];
  onSportChange: (newSportId: string | string[]) => void;
}

const SportFilter: React.FC<SportFilterProps> = ({sports, onSportChange}) => {
  const handleSportChange = useCallback(
    (newSportId: string | string[]) => {
      const sportsArray = Array.isArray(newSportId) ? newSportId : [newSportId];
      onSportChange(sportsArray);
    },
    [onSportChange]
  );

  return (
    <FormControl fullWidth>
      <SportSelectInput
        value={sports}
        onChange={handleSportChange}
        multiple={true}
      />
    </FormControl>
  );
};

export default SportFilter;
